import {createStack} from '@famly/mf_layout_stack';

/**
 * ModalFooter component
 *
 * A simple wrapper for the modal's bottom elements, typically containing action buttons.
 * Used as a container for ModalFooterButtons and other footer content.
 *
 * @example
 * <ModalFooter>
 *   <ModalFooterButtons>
 *     <ModalDeleteButton onClick={handleDelete} />
 *     <ModalSecondaryButton text="Cancel" onClick={handleCancel} />
 *     <ModalPrimaryButton text="Save" onClick={handleSave} />
 *   </ModalFooterButtons>
 * </ModalFooter>
 */
export const ModalFooter = createStack({component: 'footer', flexDirection: 'column'});
